export const CarouselType = {
  CAROUSEL: "carousel",
  DOTS: "carousel_dots",
  ARROWS: "carousel_arrow",
  MARKET: "carousel_market",
};
